import _ from 'lodash'

const recordUtil = {

	/**
	 * Returns true if the current record exists solely in the dataset, and not
	 * in the remote data source. Note with the introduction of the Forms
	 * section in Impact 4.0.2, we began referring to these records as "Manually
	 * Added Record"s
	 * @param {DatasetRecord} record
	 */
	isSupplementalOnly(record) {
		return _.get(record, 'new', true)
	},

	/**
	 * Returns true if the current record is being created for the first
	 * time.  If you go back later to edit this record, this method will
	 * return false, but {@link #isSupplementalOnly} will return true.
	 * @param {DatasetRecord} record
	 */
	isNewRecord: function(record) {
		return !_.get(record, 'record')
	}
}

export default recordUtil

recordUtil.__filename__ = 'datasets/records/record-util.js'
